<div *ngIf="show" @fadeInOut class="wholesaler-integration-dialog-container">
  <div class="dialog-header">
    Wholesaler Integration
  </div>

  <app-gather-credentials *ngIf="progress === WholesalerIntegrationStepsEnum.SelectType"
                          (cancel)="cancel.emit()"
                          (nextStep)="setNextStep($event)"
  ></app-gather-credentials>

  <app-test-connection *ngIf="progress !== WholesalerIntegrationStepsEnum.SelectType"
                       [wholesalerIntegration]="wholesalerIntegration"
                       [progress]="progress"
                       (back)="setNextStep($event)"
                       (next)="setNextStep($event)"
                       (save)="save.emit($event)"
  ></app-test-connection>
</div>
